module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "width-wrapper"
  }, [_c('div', {
    ref: "table",
    staticClass: "table"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "300px"
    }
  }, [_c('material-input', {
    attrs: {
      "parentClass": "",
      "label": "ID или Название",
      "valueStr": _vm.searchStr
    },
    on: {
      "inputStr": _vm.inputStr
    }
  })], 1)]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.productList), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _c('td', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "photo-item",
      style: ({
        'background-image': ("url('" + (product.photos.FRONT) + "')")
      })
    })]), _vm._v(" "), _c('td', {
      staticClass: "title",
      on: {
        "dblclick": function($event) {
          return _vm.$router.push({
            path: ("/products/" + (product.id))
          })
        }
      }
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.heading ? product.heading.title : ''))])])
  }), 0)]), _vm._v(" "), (_vm.next != null) ? _c('a', {
    ref: "nextLink",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Товары")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Рубрика\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7641b69d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Products.vue
// module id = 249
// module chunks = 1